module.exports = __webpack_public_path__ + "media/2.d24faf90.mp3";